import { useRef, useState } from "react";
import { Upload, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const SLOTS = [
  ["cover", "Cover image", "image/jpeg,image/png,image/webp"], ["complete", "Complete edition PDF", ".pdf"], ["vol1", "Volume I PDF", ".pdf"], ["vol2", "Volume II PDF", ".pdf"],
  ["vol3", "Volume III PDF", ".pdf"], ["sample", "Free sample PDF", ".pdf"], ["toolkit", "Toolkit app (HTML)", ".html,.htm"],
  ["software_zip", "Software pack (zip)", ".zip"], ["bundle", "Full bundle (zip)", ".zip"],
];
const mb = (b) => `${(b / 1048576).toFixed(1)} MB`;

const Slot = ({ g, slot: [key, label, accept], onUploaded }) => {
  const ref = useRef(null);
  const [pct, setPct] = useState(null);
  const f = g.files[key];
  const pick = async (file) => {
    if (!file) return;
    setPct(0);
    try {
      await api.put(`/relocation/guides/${g.id}/files/${key}`, file, {
        headers: { "Content-Type": "application/octet-stream", "x-filename": encodeURIComponent(file.name).replace(/%20/g, " ") },
        onUploadProgress: (e) => e.total && setPct(Math.round((e.loaded / e.total) * 100)),
      });
      toast.success(`${label} uploaded`);
      onUploaded();
    } catch (e) { toast.error(errMsg(e)); } finally { setPct(null); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="flex items-center gap-4 px-5 py-4 border-b border-[#E2D9CC] last:border-0" data-testid={`kit-slot-${key}`}>
      <span className={`w-6 h-6 grid place-items-center shrink-0 ${f ? "bg-[#3B1B48] text-[#C59B27]" : "border border-[#E2D9CC]"}`}>{f && <Check className="w-3.5 h-3.5" />}</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-[#1C181D]">{label}</p>
        <p className="text-xs text-[#8C827A] truncate" data-testid={`kit-file-${key}`}>{f ? `${f.filename} · ${mb(f.size)}` : "Not uploaded"}</p>
        {pct !== null && <div className="h-1 bg-[#EFE6F3] mt-2"><div className="h-full bg-[#C59B27]" style={{ width: `${pct}%` }} /></div>}
      </div>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={(e) => pick(e.target.files[0])} data-testid={`kit-input-${key}`} />
      <button data-testid={`kit-upload-${key}`} onClick={() => ref.current.click()} disabled={pct !== null || g.running}
        className="inline-flex items-center gap-2 border border-[#E2D9CC] px-3 py-2 text-xs hover:border-[#3B1B48] disabled:opacity-50">
        {pct !== null ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}{f ? "Replace" : "Upload"}
      </button>
    </div>
  );
};

export const KitFiles = ({ g, onUploaded }) => (
  <div data-testid="reloc-kit-files">
    <p className="text-sm text-[#8C827A] mb-4 max-w-2xl">Upload or replace any of this guide's files. New product files (volumes, complete edition, toolkit, bundle) are added to the store listing with standard prices, which you can edit in Store listing.</p>
    <div className="bg-[#FAF7F2] border border-[#E2D9CC] max-w-3xl">{SLOTS.map((s) => <Slot key={s[0]} g={g} slot={s} onUploaded={onUploaded} />)}</div>
  </div>
);
